<template>
    <div><a @click.prevent="$router.go(-1)">← Back</a></div>
</template>

<script>
export default {
  name: 'BackLink',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
